import script from "./IncidentSearchComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncidentSearchComponent.vue?vue&type=script&setup=true&lang=ts"

import "./IncidentSearchComponent.vue?vue&type=style&index=0&id=c87b1776&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c87b1776"]])

export default __exports__